// パスワード忘れ : パスワードを忘れた際のパスワード設定前のメール認証処理 /password_register1
import React, {Component} from 'react';
import validator from 'email-validator';
import ToggleDisplay from 'react-toggle-display';
import Header from './header';
import Footer from './footer';
import './css/passwordReset.css';
import firebase from "firebase";
import define from './define';

const delimiter = '{{{{{}}}}}';

export default class passwordReset1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      sendSuccess: false,
      isInvalidEmail: false,
      uid: '',
      errorMessage: '',
    }
  }

  handleChangeEmail = (e) => {
    this.setState({ email: e.target.value });
  }

  // send email
  sendMail = async(e) => {
    e.preventDefault();

    if (0 === this.state.email.length) {
      this.setState({ errorMessage: '※メールアドレスを入力してください' });
      this.setState({ isInvalidEmail: true });
      return;
    }

    if(!validator.validate(this.state.email)) {
      // validation error
      this.setState({ errorMessage: '※不正なメールアドレスです' });
      this.setState({ isInvalidEmail: true });
      return;
    }

    const headers = new Headers()
    headers.append('Content-Type','application/json');
    let endPoint = `/api/searchEmail?email=${this.state.email}`
    let options = {
      method:'GET',
      headers,
    }

    const res = await fetch(endPoint, options)
    const body = await res.json()
    
    if (!body.isEmail) {
      this.setState({ errorMessage: '※ご登録がないメールアドレスです' });
      this.setState({ isInvalidEmail: true });
      return
    }

    this.setState({ uid: body.uid });
    this.setState({ isInvalidEmail: false });
    // send email
    const mailSubject = 'MyRate | パスワード再設定認証用メール';
    const createParam = '?m=' + this.encoding(this.state.email);
    const mailBody = '下記のリンクからメールアドレスの再設定を行ってください。\nなお、この認証メールのURLをクリックするまでは、登録は完了しません。\n' + window.location.origin + '/password_reset2' + createParam + '\n※リンクの有効期限は、発行してから24時間となります。'
    const params = {
      'sendToUsers':[ this.state.email ],
      'mailSubject': mailSubject,
      'mailBody': mailBody,
    };
    // テスト、ベトナム環境ではメールが飛ばないためリンク出力
    const { projectId } = define.FIREBASE_CONFIG;
    if ('localhost' !== window.location.hostname && ('n-lisence-local'=== projectId || 'n-license-apv' === projectId)) {
      console.log(window.location.origin + '/password_reset2' + createParam);
      this.setState({ isLoad: false });
      this.setState({ sendSuccess: true });
      return;
    }
    
    endPoint = '/api/sendmail';
    options = {
      method:'POST',
      headers,
      body:JSON.stringify(params)
    };
    fetch(endPoint, options)
      .then(res => {
        if(!res.ok) {
          alert('エラーが発生しました');
        }
        return res.json();
      })
      .then(json => {
        if(!json.res.error.length) {
          this.setState({ sendSuccess: true });
        }
      })
      .catch((error) => {
        console.log(error)
        alert('エラーが発生しました');
      })
  }

  // create query
  encoding = (email) => {
    return Buffer.from(email + delimiter + Date.now() + delimiter + this.state.uid).toString('base64');
  }

  showContent = () => {
    if (this.state.sendSuccess) {
      return (
        <React.Fragment>
          <img className="title_icon" src="/img/common/img_mail.png" alt=""/>
          <p className="subtitle">入力されたメールアドレス宛に<br/>認証用のメールを送信しました！</p>
          <div className="text-notification">
            <p>メールに記載されたURLをクリックし、パスワードの再設定を行ってください。<br/>※リンクの有効期限は、発行してから24時間となります。</p>
          </div>
        </React.Fragment>
      )
    }

    return (
      <React.Fragment>
        <h2 className="title">パスワード忘れ</h2>
        <form className="form-password-reset">
        <ToggleDisplay if={ this.state.isInvalidEmail }>
          <p>{ this.state.errorMessage }</p>
        </ToggleDisplay>
          <input type="text" placeholder="登録メールアドレスを入力ください" onChange={e => this.handleChangeEmail(e)}></input>
          <button className="submit" type="button" onClick={e => this.sendMail(e)}>パスワード再発行メールを送る</button>
        </form>
      </React.Fragment>
    )
  }

  render () {
    return (
      <div id="wrapper">
        <div id="" className="wrapper-lp wrapper-passwordReset1">
          <Header />
          <div className="webWrap">
            <div className="wrapCover">
              <div className="wrapCover__contentBlock clearfix">
                <div className="content-top">
                  <div className="block-passwordReset1">
                    { this.showContent() }
                  </div>
                </div>
              </div>
              <Footer/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/passwordReset1.js